import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

import { authReducer } from "@/store/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  // RTK Query goes here once we add it (Phase 3+) via api.middleware.
});

export type RootState  = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch  = useDispatch.withTypes<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
